import { useState } from "react";

import Fallback from "@/containers/Episode/partials/Cover/partials/Fallback";
import { cx } from "@/utils";
import HoverCard from "@components/HoverCard";

import { POINT_DIAMETER } from "../settings";
import { Point } from "../types";
import Info from "./Info";

import styles from "../ImpactScore.module.css";

const ChannelPoint = ({
  onClick,
  ...point
}: Point & { onClick: () => void }) => {
  const [loaded, setLoaded] = useState(false);
  const onLoad = () => {
    setLoaded(true);
  };

  return (
    <HoverCard openDelay={0} closeDelay={0} content={<Info {...point} />}>
      <div
        onClick={onClick}
        className={styles.channel}
        style={{
          width: `${POINT_DIAMETER}px`,
          height: `${POINT_DIAMETER}px`,
          left: `${point.left}%`,
          top: `${point.top}%`,
        }}
      >
        <Fallback className={styles.img} source={point.channel.channel_type} />

        <img
          className={cx(styles.img, { [styles.visible]: loaded })}
          src={point.channel.artwork_url}
          onLoad={onLoad}
        />
      </div>
    </HoverCard>
  );
};
export default ChannelPoint;
